export const hadleFilterStructureData = (filters) => {
  const filterKeys = [];
  const filterColors = [];

  for (const key in filters) {
    console.log('filters[key]', filters[key]);
    if (filters[key]?.options?.length) {
      filterKeys.push({
        title: filters[key]?.label,
        titleCode: filters[key]?.code,
        options: filters[key]?.options,
      });
    }

    // if (key == "color") {
    //   filterColors.push({
    //     title: key,
    //     list: filters[key]?.buckets,
    //   });
    // }
  }

  return { filterKeys, filterColors };
};

export function getObjectsInData(arr){
  let result = [];
  function handleData(arr) {

    arr?.forEach(item => {
  
      if(result.length == 0 || result?.find(itemF => itemF.id != item.id)){
        result.push(item);    
      }
  
      if (Array.isArray(item?.children_data) && item?.children_data && item?.children_data?.length > 0) {
        handleData(item?.children_data)
      }
    });
    
  }
  handleData(arr)
  return result
}